import { trigger, state, style, transition, animate } from '@angular/animations';

import { Component, Inject, ViewChild, DOCUMENT } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { AppService } from './_services/app.service';

// imports for codemirror
import 'codemirror/mode/javascript/javascript';
import 'codemirror/lib/codemirror';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/sql/sql';
import 'codemirror/addon/edit/closetag';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/anyword-hint';
import 'codemirror/addon/hint/sql-hint';
import 'codemirror/addon/selection/active-line';
import 'codemirror/addon/scroll/annotatescrollbar';
import 'codemirror/addon/search/matchesonscrollbar';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/match-highlighter';
import 'codemirror/addon/display/autorefresh';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';


export const MY_FORMATS = {
  parse: {
    dateInput: 'D MMM YYYY',
  },
  display: {
    dateInput: 'D MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    animations: [
        trigger('slider', [
            state('*', style({
                width: '250px'
            })),
            state('show', style({
                width: '50px'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ]),
        trigger('sliderContent', [
            state('*', style({
                left: '250px',
                width: '{{pageWidth}}px' // avoiding overflow
            }), { params: { pageWidth: 0 } }),
            state('show', style({
                left: '50px',
                width: '{{pageWidth}}px'
            }), { params: { pageWidth: 0 } }),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AppComponent {

  @ViewChild(SidebarComponent) miniSidebar: SidebarComponent;
  currentWindowWidth: number;
  lastUrl: string = '';

  constructor(public service: AppService,  private http: HttpClient, public translate: TranslateService, private title: Title, @Inject(DOCUMENT) private document: Document, @Inject('BASE_URL') public baseUrl: string, private router: Router) {

    this.translate.use(this.service.getLocalLanguage());

    const temp = new Promise((resolve, reject) => {
      service.CheckAuth().then(res => {
        this.AddStyling();
        if (res) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });

    router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.url != this.lastUrl) {
        this.lastUrl = event.url;

        if (service.addOnUrl) {
          this.lastUrl += '/' + service.addOnUrl;
        }

        http.post(baseUrl + 'api/common/updateUserActivity', {
          Data: this.lastUrl
        }).subscribe();
      }
    });
  }

  AddStyling() {// Adding css styles to the system
    const stylings = this.document.getElementById('grss_theme');
    if (this.service.currentUser.siteTitle) {
      this.title.setTitle(this.service.currentUser.siteTitle);
    }
    if (!stylings) {
      let theme = 'theme';
      if (this.service.currentUser.isTestingEnabled === true) {
        theme = 'theme-uat';
      }
      const head = this.document.getElementsByTagName('head')[0];
      const themeStyle = this.document.createElement('link');
      themeStyle.id = 'grss_theme';
      themeStyle.rel = 'stylesheet';
      themeStyle.href = `${this.baseUrl + 'styles/' + theme + '.css'}`;
      head.appendChild(themeStyle);
    }
  }

  hideMouseHoverMiniSidebar() {
    this.miniSidebar.OnMouseOut();
  }

  onResize(event) {
    this.currentWindowWidth = event.target.innerWidth; // window width

    const element = this.document.getElementById('matDrawerContent');
    if (element) {
      element.style.width = this.getCurrentWidth().toString() + 'px';
    }
  }

  getCurrentWidth(): number {
    let width: number = 0;
    if (this.currentWindowWidth) {
      if (!this.service.miniSidebarOpen) {
        width = this.currentWindowWidth - 250;
      } else {
        width = this.currentWindowWidth - 50;
      }
    } else {
      if (!this.service.miniSidebarOpen) {
        width = window.innerWidth - 250;
      } else {
        width = window.innerWidth - 50;
      }
    }
    return width;
  }


}

